import { render, staticRenderFns } from "./EditDetails.vue?vue&type=template&id=5caed262&scoped=true"
import script from "./EditDetails.vue?vue&type=script&lang=js"
export * from "./EditDetails.vue?vue&type=script&lang=js"
import style0 from "./EditDetails.vue?vue&type=style&index=0&id=5caed262&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5caed262",
  null
  
)

export default component.exports